import React from "react";
import Button from "../../../shared/components/Button/Button";
import ProgressBar from "../../../shared/components/ProgressBar/ProgressBar";
import { useNfe } from "../hooks/useNfe";
import { canEmit, canRefresh, fiscalStatusInfo } from "../utils/fiscal";
import "./NfePanel.css";

/**
 * Estado da NF-e (Bling) do pedido, com emitir / consultar SEFAZ / ver DANFE.
 * @param {object} order pedido (usa _id e fiscal)
 * @param {(fiscal: object) => void} [onChange] chamado com o estado fiscal novo
 */
const NfePanel = ({ order, onChange }) => {
  const { fiscal, busy, error, progress, emit, refresh } = useNfe(
    order,
    onChange,
  );
  const info = fiscalStatusInfo(fiscal);
  const danfe = fiscal?.linkDanfe || fiscal?.linkPDF;

  return (
    <div className="nfe-panel">
      <div className="nfe-panel__header">
        <h6 className="nfe-panel__title">Nota fiscal (Bling)</h6>
        <span className={`nfe-panel__badge nfe-panel__badge--${info.tone}`}>
          {info.label}
        </span>
      </div>

      {fiscal?.fake && (
        <p className="nfe-panel__test">
          Nota de teste (homologação) — sem valor fiscal
        </p>
      )}

      {progress && (
        <ProgressBar
          value={progress.percent}
          label={progress.label}
          detail="A primeira nota de um produto demora mais: ele é cadastrado no Bling antes."
        />
      )}

      {fiscal?.numero && (
        <p className="nfe-panel__line">
          NF-e nº <strong>{fiscal.numero}</strong>
          {fiscal.serie ? ` · série ${fiscal.serie}` : ""}
        </p>
      )}
      {fiscal?.chaveAcesso && (
        <p className="nfe-panel__line nfe-panel__key" title="Chave de acesso">
          {fiscal.chaveAcesso}
        </p>
      )}
      {(error || (fiscal?.status === "error" && fiscal?.error)) && (
        <p className="nfe-panel__error" role="alert">
          {error || fiscal.error}
        </p>
      )}

      <div className="nfe-panel__actions">
        {canEmit(fiscal) && (
          <Button onClick={emit} disabled={busy}>
            {busy
              ? "Emitindo…"
              : fiscal?.status
                ? "Tentar emitir de novo"
                : "Emitir NF-e"}
          </Button>
        )}
        {canRefresh(fiscal) && (
          <Button variant="secondary" onClick={refresh} disabled={busy}>
            {busy ? "Consultando…" : "Consultar SEFAZ"}
          </Button>
        )}
        {danfe && (
          <a
            className="svelta-btn svelta-btn--secondary"
            href={danfe}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver DANFE
          </a>
        )}
      </div>
    </div>
  );
};

export default NfePanel;
